import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from '@/api/queryClient';
import { useRestoreSession } from '@/features/auth/hooks/useRestoreSession';
import { ErrorBoundary } from '@/shared/ErrorBoundary';
import { AppRoutes } from '@/routes';

function Shell() {
  const resolved = useRestoreSession();

  if (!resolved) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-gray-500">Checking your session…</p>
      </div>
    );
  }

  return <AppRoutes />;
}

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
